export const HD_BASIC_INFO = 'HD_BASIC_INFO';
export const HD_UPDATE_BASIC_INFO = 'HD_UPDATE_BASIC_INFO';
export const CHANGE_HD_INFO_OVERLAY = 'CHANGE_HD_INFO_OVERLAY';
export const CLEAR_CONTRACT_VIEW = 'CLEAR_CONTRACT_VIEW';
export const PORTFOLIO_LIST = 'PORTFOLIO_LIST';
export const HDLINE_LOADER = 'HDLINE_LOADER';
